import { Box, IconButton, styled, Tab, Tabs } from "@mui/material";

export const StyledTabsWrapper = styled(Box)(({ theme, tabLabel, responsiveMode }) => ({
    backgroundColor: tabLabel === "Pickups" || tabLabel === "Shipments"
        ? theme.palette.custom.selectTabBackgroundColor
        : theme.palette.custom.tabBackgroundColor,
    borderRadius: 8,
    padding: 8,
    display: "inline-flex",
    maxWidth: "100%",
    ...(responsiveMode && {
        // flex: 1,
        minWidth: 0,
    }),
    border:
        tabLabel === "Pickups" || tabLabel === "Shipments"
            ? theme.borders.warning
            : theme.borders.orderCards,
    alignItems: "center",
    [theme.breakpoints.down("lg")]: {
        marginBottom: '16px',
    },
}));

export const StyledTabs = styled(Tabs)(({ responsiveMode }) => ({
    minHeight: "unset",
    width: "100%",
    ...(responsiveMode && {
        "& .MuiTabs-scroller": {
            overflowX: "auto !important",
        },
    }),
}));

export const StyledTab = styled(Tab)(({ theme, tabLabel, responsiveMode }) => ({
    textTransform: "none",
    fontWeight: 500,
    fontSize: theme.typography.base.fontSize,
    borderRadius: 6,
    padding: "10px 28px",
    minHeight: "unset",
    textDecoration: 'none',
    minWidth: 80,
    color: '#5C5C5C',
    "&.Mui-selected": {
        backgroundColor: tabLabel === "Pickups" || tabLabel === "Shipments"
            ? theme.palette.custom.warning
            : theme.palette.primary.main,
        color: theme.palette.custom.white,
    },
    ...(responsiveMode && {
        [theme.breakpoints.down("lg")]: {
            padding: "10px 20px",
            minWidth: "fit-content",
        },
    }),
}));
export const StyledMenuButton = styled(IconButton)(() => ({
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "flex-start",
}));

export const StyledSelectedLabel = styled(Box)(({ theme }) => ({
    marginLeft: 8,
    fontWeight: 500,
    fontSize: theme.typography.medium.fontSize,
    lineHeight: 1.2,
    [theme.breakpoints.down("sm")]: {
        fontSize: theme.typography.base.fontSize,
    },
}));
